__turbopack_context__.v({
  "alignLeft": "HeroSection-module__gnKjra__alignLeft",
  "alignRight": "HeroSection-module__gnKjra__alignRight",
  "bulletIcon": "HeroSection-module__gnKjra__bulletIcon",
  "ctaContainer": "HeroSection-module__gnKjra__ctaContainer",
  "ctaContent": "HeroSection-module__gnKjra__ctaContent",
  "fadeIn": "HeroSection-module__gnKjra__fadeIn",
  "iconContainer": "HeroSection-module__gnKjra__iconContainer",
  "iframeContainer": "HeroSection-module__gnKjra__iframeContainer",
  "imgContainer": "HeroSection-module__gnKjra__imgContainer",
  "overlay": "HeroSection-module__gnKjra__overlay",
  "root": "HeroSection-module__gnKjra__root",
  "subtitle": "HeroSection-module__gnKjra__subtitle",
  "subtitleLight": "HeroSection-module__gnKjra__subtitleLight",
  "tag": "HeroSection-module__gnKjra__tag",
  "title": "HeroSection-module__gnKjra__title",
  "titleLight": "HeroSection-module__gnKjra__titleLight",
});
